import React, {useState, useEffect} from 'react'
import styled from 'styled-components'
import Modal from 'react-modal'

import buttonImg from '../../../../../static/images/modals/images/close.svg'

let customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgb(0, 31, 45, 0.8)',
        zIndex: 20,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '800px',
        padding: '0px',
        borderRadius: '2px',
    }
};

Modal.setAppElement('body')

const ModalSafeRecreation = ({ text, modalState, setModalState }) => {
    // const [width, setWidth] = useState(window.innerWidth)

    useEffect(() => {
        // const handleResize = () => setWidth(window.innerWidth)
        document.body.style.height = "100%";
        document.body.style.overflowY = "scroll";
        // window.addEventListener("resize", handleResize)
        // if (width < 600)
        //     customStyles['content']['height'] = '80%';
        // else
        //     customStyles['content']['height'] = 'unset';
        // return () => {
        //     window.removeEventListener("resize", handleResize)
        // }
    });

    function closeModal() {
        setModalState(false);
        document.body.style.height = "unset";
        document.body.style.overflowY = "unset";
    }

    return (
        <ModalSafeRecreationStyle>
            <Modal
                isOpen={modalState}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel={text.title}
                shouldCloseOnOverlayClick={true}
                className="modal-safe-recreation"
            >
                <CloseModal onClick={() => closeModal()}>
                    <ButtonImage/>
                </CloseModal>
                <Wrapper>
                    <TextWrapper>
                        <Title>
                            {text.title}
                        </Title>
                        <Description>
                            {text.description}
                        </Description>
                    </TextWrapper>
                </Wrapper>
            </Modal>
        </ModalSafeRecreationStyle>
    )
}

export default ModalSafeRecreation

const ModalSafeRecreationStyle = styled.div`
  position: relative;
  @media ${({ theme }) => theme.breakpoints.mobile} {
    overflow-y: auto;
  }
`

const CloseModal = styled.button`
  border: none;
  position: absolute;
  top: 4rem;
  right: 4rem;
  background: none;
`

const ButtonImage = styled.div`
  background-image: url(${buttonImg});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 2.4rem;
  height: 2.4rem;
`

const Wrapper = styled.div`
  height: 100%;
  margin-top: 8.5rem;
  margin-bottom: 4.8rem;
  margin-left: 6.1rem;
  margin-right: 6.1rem;
  display: flex;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

`

const Title = styled.h4`
  font-family: Sequel75;
  color: ${({theme}) => theme.colors.secondary};
  font-size: 2rem;
  line-height: 2.7rem;
`

const Description = styled.p`
  margin-top: 2rem;
  font-family: Sequel55;
  color: ${({theme}) => theme.colors.primary};
  font-size: 2rem;
  line-height: 2.7rem;
  @media ${({ theme }) => theme.breakpoints.mobile} {
    padding-bottom: 4.8rem;
  }  
`
